module.exports = __webpack_public_path__ + "static/media/Lesson-4-9-The-Church-Comes-Alive.7f4f426d.pdf";